<template>
  <div class="ScholarshipApply">
    <!-- 首頁圖 -->
    <div ref="banner" class="banner">
      <h1>{{ $t("nav.scholarship") }}</h1>
    </div>
    <!-- 申請時序 -->
    <div class="content-container">
      <!-- 標題 -->
      <div ref="first_tit" class="title">
        <span>{{ $t("externalsportsprogrammes.tit") }}</span>
      </div>
      <!-- 其他注意事项 -->
      <div class="other-tips-container">
        <p v-for="item in externalsportsprogrammes.conlist" :key="item" v-html="item"></p>
      </div>
      <CoButton href="https://drive.google.com/file/d/11b_q1XNfdro7Baa4CFIwnPp3DkQrEasm/view?usp=sharing" class="apply-btn">
        {{ externalsportsprogrammes.btn }}
      </CoButton>
    </div>
    <CommonSlogan />
  </div>
</template>

<script>
import CoButton from "../components/co-button/co-button.vue";
import CommonSlogan from "../components/CommonSlogan.vue";
export default {
  name: "ScholarshipApply",
  data() {
    return {
      selectTimeItem: 0,
    };
  },
  components: { CommonSlogan, CoButton },
  methods: {
    changeTimeLine(index) {
      this.selectTimeItem = index;
    }
  },
  computed: {
    externalsportsprogrammes: function() {
      return this.$t("externalsportsprogrammes");
    },
  },
};
</script>

<style scoped lang="scss">
.ScholarshipApply {
  .banner {
    background-image: url("../assets/img/apply/scholarship.jpg");
  }
  .content-container {
    background: rgba($color: white, $alpha: 0.3);
    .other-tips-container {
      margin-top: 50px;
      &>p{
        margin-bottom: 1%;
      }
    }
    .apply-btn {
      display: block;
      width: 20%;
      margin: 20px auto;
    }
  }
}

@media screen and (max-width: 768px) {
  .ScholarshipApply {
    .banner {
      height: 40vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-image: url("../assets/img/apply/scholarship.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      color: white;
      h1 {
        line-height: 14vw;
        font-size: 7vw;
      }
    }
    .content-container {
      width: 90%;
      margin: 0 auto 4.4vw;
      background: rgba($color: white, $alpha: 0.3);
      .title {
        color: #85c456;
        margin: 3.4vw auto 2.8vw;
        font-size: 5vw;
        & > span {
          border-bottom: solid 0.5vw #22a0d6;
          padding-bottom: 1vw;
        }
      }
      .other-tips-container {
        margin-top: 20px;
      }
      .desc {
        font-size: 3vw;
      }
      .more-btn {
        width: 40%;
      }
    }
  }
}
</style>
